// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PVk0","rootNoMargin":"styles_rootNoMargin__1sZB8"};